import QueueService from '@/services/QueueService';

export default {
  namespaced: true,
  state: {
    length: 0,
    list: null,
    averageChild: 0,
    activeList: null,
    deadList: null,
    listByMonthAndYear: null,
    listByMonthAndYearLength: 0,
    listByBranche: null,
    listByBrancheLength: 0,
    listByState: null,
    listByStateLength: 0,
    listReferenced: null,
    listReferencedLength: 0,
    listReferencedByBranche: null,
    listReferencedByBrancheLength: 0,
  },
  mutations: {
    m_length(state: any, length: Number) {
      state.length = length;
    },
    m_list(state: any, list: any) {
      state.list = list;
    },
    m_averageChild(state: any, averageChild: Number) {
      state.averageChild = averageChild;
    },
    m_activeList(state: any, activeList: any) {
      state.activeList = activeList;
    },
    m_deadList(state: any, deadList: any) {
      state.deadList = deadList;
    },
    m_listByMonthAndYear(state: any, listByMonthAndYear: any) {
      state.listByMonthAndYear = listByMonthAndYear;
    },
    m_listByMonthAndYearLength(state: any, length: Number) {
      state.listByMonthAndYearLength = length;
    },
    m_listByBranche(state: any, listByBranche: any) {
      state.listByBranche = listByBranche;
    },
    m_listByBrancheLength(state: any, length: Number) {
      state.listByBrancheLength = length;
    },
    m_listByState(state: any, listByState: any) {
      state.listByState = listByState;
    },
    m_listByStateLength(state: any, length: Number) {
      state.listByStateLength = length;
    },
    m_listReferenced(state: any, list: any) {
      state.listReferenced = list;
    },
    m_listReferencedLength(state: any, length: Number) {
      state.listReferencedLength = length;
    },
    m_listReferencedByBranche(state: any, list: any) {
      state.listReferencedByBranche = list;
    },
    m_listReferencedByBrancheLength(state: any, length: Number) {
      state.listReferencedByBrancheLength = length;
    },
  },
  actions: {
    async a_init_Queue({ dispatch }: any, { params }: any) {
      await dispatch('a_get_length');
      await dispatch('a_get_list');
      await dispatch('a_get_averageChild');
      await dispatch('a_get_activeList');
      await dispatch('a_get_deadList');
      await dispatch('a_get_listReferenced');
      await dispatch('a_get_listReferencedLength');

      if (params) {
        if (params.listByMonthAndYear) await dispatch('a_get_listByMonthAndYear', params.listByMonthAndYear);
        if (params.listByMonthAndYear) await dispatch('a_get_listByMonthAndYearLength', params.listByMonthAndYear);
        if (params.listByBranche) await dispatch('a_get_listByBranche', params.listByBranche);
        if (params.listByBranche) await dispatch('a_get_listByBrancheLength', params.listByBranche);
        if (params.listByState) await dispatch('a_get_listByState', params.listByState);
        if (params.listByState) await dispatch('a_get_listByStateLength', params.listByState);
        if (params.listReferencedByBranche) await dispatch('a_get_listReferencedByBranche', params.listReferencedByBranche);
        if (params.listReferencedByBranche) await dispatch('a_get_listReferencedByBrancheLength', params.listReferencedByBranche);
      }
    },
    async a_get_length({ commit }: any) {
      await QueueService.getListLength().then((res: any) => {
        if (res.status === 200) {
          commit('m_length', res.data.lineCount);
        }
      });
    },
    async a_get_list({ commit, dispatch }: any) {
      await QueueService.getList().then((res: any) => {
        if (res.status === 200) {
          commit('m_list', res.data);
        }
      });
    },
    async a_get_listWithChildren({ commit, dispatch }: any) {
      await QueueService.getList().then((res: any) => {
        if (res.status === 200) {
          const data: Array<any> = [];
          res.data.forEach(async (element :any) => {
            element.kidCount = await dispatch('a_get_kidsForLine', { line: element });
            data.push(element);
          });
          commit('m_list', data);
        }
      });
    },
    async a_get_averageChild({ commit }: any) {
      await QueueService.getListAverageChild().then((res: any) => {
        if (res.status === 200) {
          commit('m_averageChild', Math.round(res.data.averageKidsPerLine));
        }
      });
    },
    async a_get_activeList({ commit }: any) {
      await QueueService.getListActive().then((res: any) => {
        if (res.status === 200) {
          commit('m_activeList', res.data);
        }
      });
    },
    async a_get_deadList({ commit }: any) {
      await QueueService.getListDead().then((res: any) => {
        if (res.status === 200) {
          commit('m_deadList', res.data);
        }
      });
    },
    async a_get_listByMonthAndYear({ commit }: any, { month, year }: any) {
      await QueueService.getListByMonthAndYear({ month, year }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByMonthAndYear', res.data);
        }
      });
    },
    async a_get_listByMonthAndYearLength({ commit }: any, { month, year }: any) {
      await QueueService.getListByMonthAndYearLength({ month, year }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByMonthAndYearLength', res.data.lineCount);
        }
      });
    },
    async a_get_listByBranche({ commit }: any, { branche }: any) {
      await QueueService.getListByBranche({ branche }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByBranche', res.data);
        }
      });
    },
    async a_get_listByBrancheWithChildren({ commit, dispatch }: any, { branche }: any) {
      await QueueService.getListByBranche({ branche }).then((res: any) => {
        console.log(res);
        if (res.status === 200) {
          const data: Array<any> = [];
          res.data.forEach(async (element :any) => {
            element.kidCount = await dispatch('a_get_kidsForLine', { line: element });
            data.push(element);
          });
          commit('m_listByBranche', data);
        }
      });
    },
    async a_get_listByBrancheLength({ commit }: any, { branche }: any) {
      await QueueService.getListByBrancheLength({ branche }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByBrancheLength', res.data.lineCount);
        }
      });
    },
    async a_get_listByState({ commit }: any, { state }: any) {
      await QueueService.getListByState({ state }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByState', res.data);
        }
      });
    },
    async a_get_listByStateLength({ commit }: any, { state }: any) {
      await QueueService.getListByStateLength({ state }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listByStateLength', res.data.lineCount);
        }
      });
    },
    async a_get_listReferenced({ commit }: any) {
      await QueueService.getListReferenced().then((res: any) => {
        if (res.status === 200) {
          commit('m_listReferenced', res.data);
        }
      });
    },
    async a_get_listReferencedLength({ commit }: any) {
      await QueueService.getListReferencedLength().then((res: any) => {
        if (res.status === 200) {
          commit('m_listReferencedLength', res.data.lineCount);
        }
      });
    },
    async a_get_listReferencedByBranche({ commit }: any, { params }: any) {
      await QueueService.getListReferencedByBranche(params).then((res: any) => {
        if (res.status === 200) {
          commit('m_listReferencedByBranche', res.data);
        }
      });
    },
    async a_get_listReferencedByBrancheLength({ commit }: any, { params }: any) {
      await QueueService.getListReferencedByBrancheLength(params).then((res: any) => {
        if (res.status === 200) {
          commit('m_listReferencedByBrancheLength', res.data.lineCount);
        }
      });
    },
    async a_get_kidsForLine({ commit }:any, { line }: any) {
      return await QueueService.getChildrenForLine(line).then((res: any) => {
        if (res.status === 200) {
          return res.data.kidCount;
        }
      });
    },
  },
  getters: {
    length: (state: any) => state.length,
    list: (state: any) => state.list,
    averageChild: (state: any) => state.averageChild,
    activeList: (state: any) => state.activeList,
    deadList: (state: any) => state.deadList,
    listByMonthAndYear: (state: any) => state.listByMonthAndYear,
    listByBranche: (state: any) => state.listByBranche,
    listByState: (state: any) => state.listByState,
    listReferenced: (state: any) => state.listReferenced,
    listReferencedByBranche: (state: any) => state.listReferencedByBranche,
    listByMonthAndYearLength: (state: any) => state.listByMonthAndYearLength,
    listByBrancheLength: (state: any) => state.listByBrancheLength,
    listByStateLength: (state: any) => state.listByStateLength,
    listReferencedLength: (state: any) => state.listReferencedLength,
    listReferencedByBrancheLength: (state: any) => state.listReferencedByBrancheLength,
  },
};
